module.exports = __webpack_public_path__ + "img/PROGRAM_REMOVED.50db4d8e.svg";